// extracted by mini-css-extract-plugin
export default {"container":"HeadsUpDisplay_container__aFnpc","layout":"HeadsUpDisplay_layout__i4Dlc"};